import styled from '@emotion/styled';
import * as T from '../../components/Typography';

export const StyledH3 = styled(T.H4SemiBold)`
  color: ${({ theme }) => theme.colors.midnight};

  ${({ theme }) => theme.media.mobile} {
    color: ${({ theme }) => theme.colors.black3};
  }
`;
